<template>
  <div class="el-table"
    :class="[{
      'el-table--fit': fit,
      'el-table--striped': stripe,
      'el-table--border': border || isGroup,
      'el-table--hidden': isHidden,
      'el-table--group': isGroup,
      'el-table--fluid-height': maxHeight,
      'el-table--scrollable-x': layout.scrollX,
      'el-table--scrollable-y': layout.scrollY,
      'el-table--enable-row-hover': !store.states.isComplex,
      'el-table--enable-row-transition': (store.states.data || []).length !== 0 && (store.states.data || []).length < 100
    }, tableSize ? `el-table--${ tableSize }` : '']"
    @mouseleave="handleMouseLeave($event)">
    <div class="hidden-columns" ref="hiddenColumns"><slot></slot></div>
    <div
      v-if="showHeader"
      v-mousewheel="handleHeaderFooterMousewheel"
      class="el-table__header-wrapper"
      ref="headerWrapper">
      <table-header
        ref="tableHeader"
        :store="store"
        :border="border"
        :default-sort="defaultSort"
        :style="{
          width: comWidth
        }">
      </table-header>
    </div>
    <div class="el-table__body-wrapper"  :class="[layout.scrollX ? `is-scrolling-${scrollPosition}` : 'is-scrolling-none']"></div>
    <div
      v-if="fixedColumns.length > 0"
      v-mousewheel="handleFixedMousewheel"
      class="el-table__fixed"
      ref="fixedWrapper"
      :style="[{
        width: layout.fixedWidth ? layout.fixedWidth + 'px' : ''
      },
      {
         height: '100%',
      }]">
      <div
        v-if="showHeader"
        class="el-table__fixed-header-wrapper"
        ref="fixedHeaderWrapper" >
        <table-header
          ref="fixedTableHeader"
          fixed="left"
          :border="border"
          :store="store"
          :style="{
            width: comWidth
          }"></table-header>
      </div>
    </div>
    <div
      v-if="rightFixedColumns.length > 0"
      v-mousewheel="handleFixedMousewheel"
      class="el-table__fixed-right"
      ref="rightFixedWrapper"
      :style="[{
        width: layout.rightFixedWidth ? layout.rightFixedWidth + 'px' : '',
        right: layout.scrollY ? (border ? layout.gutterWidth : (layout.gutterWidth || 0)) + 'px' : '',
         height: '100%'
      },
      ]">
      <div v-if="showHeader"
        class="el-table__fixed-header-wrapper"
        ref="rightFixedHeaderWrapper">
        <table-header
          ref="rightFixedTableHeader"
          fixed="right"
          :border="border"
          :store="store"
          :style="{
            width: comWidth
          }"></table-header>
      </div>
    </div>
    <div
      v-if="rightFixedColumns.length > 0"
      class="el-table__fixed-right-patch"
      ref="rightFixedPatch"
      :style="{
        width: layout.scrollY ? layout.gutterWidth + 'px' : '0',
         height: '100%'
      }"></div>
    <div class="el-table__column-resize-proxy" ref="resizeProxy" ></div>
  </div>
</template>

<script>
import { Table } from 'element-ui'
export default {
    extends: Table,
    inject: ['tableGlobal' ],
    props: {
      comWidth: {
        default: 0
      },
    },
    methods: {
          syncPostion() {
            const { scrollLeft, scrollTop, offsetWidth, scrollWidth } = this.tableGlobal.bodyWrapperData || this.bodyWrapper;
            const { headerWrapper, footerWrapper, fixedBodyWrapper, rightFixedBodyWrapper } = this.$refs;
            if (headerWrapper) headerWrapper.scrollLeft = scrollLeft;
            if (footerWrapper) footerWrapper.scrollLeft = scrollLeft;
            if (fixedBodyWrapper) fixedBodyWrapper.scrollTop = scrollTop;
            if (rightFixedBodyWrapper) rightFixedBodyWrapper.scrollTop = scrollTop;
            const maxScrollLeftPosition = scrollWidth - offsetWidth - 1;
            if (scrollLeft >= maxScrollLeftPosition) {
              this.scrollPosition = 'right';
            } else if (scrollLeft === 0) {
              this.scrollPosition = 'left';
            } else {
              this.scrollPosition = 'middle';
            }
          },
         bindEvents() {},
         unbindEvents() {},
    }
}
</script>
